const pallete = {
  grey: {
    stroke: 'rgba(109, 109, 130, 1)',
  },
  purple: {
    stroke: 'rgb(127, 48, 245)',
  },
} as const;

type StrokeWidthProps = {
  color?: string;
  size: number;
};

const allowedColors = ['grey', 'purple'] as const;
type AllowedColor = (typeof allowedColors)[number];

const StrokeWidth = ({ color = 'grey', size }: StrokeWidthProps) => {
  const safeColor: AllowedColor = allowedColors.includes(color as AllowedColor)
    ? (color as AllowedColor)
    : 'grey';
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="6" width="20" height="2" rx="1" fill={pallete[safeColor].stroke} />
      <rect x="2" y="3" width="20" height="1" rx="0.5" fill={pallete[safeColor].stroke} />
      <rect x="2" y="10" width="20" height="4" rx="1" fill={pallete[safeColor].stroke} />
      <rect x="2" y="16" width="20" height="6" rx="1" fill={pallete[safeColor].stroke} />
    </svg>
  );
};

export default StrokeWidth;
